"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TOKEN_APPROVAL = exports.GET_TOKEN_BALANCES = exports.GET_TOKEN_DATA = void 0;
exports.GET_TOKEN_DATA = `
  query GetTokenData ($id: ID!) {
    tokens(where: { id: $id }) {
      id
      decimals
      name
      symbol
      balanceScalar
      totalSupply
      totalSupplyExact
      scaledTotalSupply
      scaledTotalSupplyExact
    }
  }
`;
exports.GET_TOKEN_BALANCES = `
  query GetTokenBalances ($id: ID!, $accounts: [ID!]!) {
    tokenBalances(where: { token: $id, account_in: $accounts }) {
      id
      token {
        id
        balanceScalar
      }
      account
      value
      valueExact
    }
  }
`;
exports.GET_TOKEN_APPROVAL = `
  query GetTokenApprovals ($id: ID!, $owner: ID!, $spender: ID!) {
    tokenApprovals(where: { token: $id, owner: $owner, spender: $spender }) {
      id
      token {
        id
      }
      owner
      spender
      value
      valueExact
    }
  }
`;
//# sourceMappingURL=token.js.map